/**
 * Ryan O'Dowd
 * 2025-06-13
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const FormRow = (props: FormRowProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={[styles.container, props.style]}>
      {props.children}
    </View>
  );
};

class FormRowProps {
  children: React.ReactNode;

  style?: object;
};

FormRow.displayName = 'FormRow';
export default FormRow;
